import { MetaDecorator } from './MetaDecorator'

export { MetaDecorator }
export default MetaDecorator
